<template>
  <v-ons-col>
    <v-ons-row class="color-chart-text">
      <v-ons-col :style="minColor">低い</v-ons-col>
      <v-ons-col :style="maxColor">高い</v-ons-col>
    </v-ons-row>
    <v-ons-row class="color-chart">
      <v-ons-col
        v-for="color in colors"
        :key="color"
        :style="{ background: color }"
        class="color"
      />
    </v-ons-row>

  </v-ons-col>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        '#1c20ff',
        '#2039ff',
        '#2352ff',
        '#276bff',
        '#2a84ff',
        '#38c1ff',
        '#46fdff',
        '#44fdcf',
        '#41fc9f',
        '#40fc50',
        '#3efb00',
        '#9efd00',
        '#fdfe00',
        '#fccf00',
        '#faa000',
        '#f96300',
        '#f82500',
        '#ec2430',
        '#e02360',
        '#e02690',
        '#e029c0',
      ],
    };
  },
  computed: {
    minColor: ({ colors }) => ({ color: colors[0] }),
    maxColor: ({ colors }) => ({ color: colors.slice(-1)[0] }),
  },
};
</script>



// WEBPACK FOOTER //
// setstar.vue?1c910cba